import DocumentToValidateDetailPage from '@/pages/requests/detailPages/supplierDetailPages/DocumentToValidateDetailPage.vue'
import InvoiceCreateForm from '@/pages/requests/creationPages/InvoiceCreateTemplate.vue'
import PaymentFromApplicationForm from '@/pages/LMSGiframe/PaymentFromApplicationForm.vue'
import ProjectCreateForm from '@/pages/requests/creationPages/ProjectCreateTemplate.vue'
import SupplierCreateForm from '@/pages/requests/creationPages/SupplierCreateTemplate.vue'
import SuppliersDetailPage from '@/pages/requests/detailPages/supplierDetailPages/SupplierDetailPage.vue'
import SupplierEditPage from '@/pages/requests/editPages/SupplierEditTemplate.vue'
import SendDocumentsFromApplicationForm from '@/pages/LMSGiframe/SendDocumentsFromApplicationForm.vue'

export default [
  {
    path: '/suppliers/documentsToValidateDetails',
    alias: [],
    component: DocumentToValidateDetailPage
  },
  {
    path: '/invoices/create',
    alias: [],
    component: InvoiceCreateForm
  },
  {
    path: '/projects/create',
    alias: [],
    component: ProjectCreateForm
  },
  {
    path: '/suppliers/create',
    alias: [],
    component: SupplierCreateForm
  },
  {
    path: '/suppliers/details',
    alias: [],
    component: SuppliersDetailPage
  },
  {
    path: '/suppliers/edit',
    alias: [],
    component: SupplierEditPage
  },
  {
    path: '/sendDocumentsFromApplication/',
    component: SendDocumentsFromApplicationForm
  },
  {
    path: '/paymentFromApplication/',
    component: PaymentFromApplicationForm
  }
]



// WEBPACK FOOTER //
// ./src/routes/services/suppliers.js